export { LegalInfoModule } from './LegalInfoModule';
export { sanitizeLegalDisclaimer } from './legalInfoModule.utils';
